import { Checkbox, FormControlLabel, Button, Tooltip } from '@mui/material'
import SportsEsportsIcon from '@mui/icons-material/SportsEsports'
import { useRef, useState, useMemo } from 'react'
import SortingHandler from 'src/common/tableRelated/SortingHandler'
import BaseUITabsComponent from 'src/common/tabs/BaseUITabs'
import { EVENT_TYPE_THERAPY_SESSION, EVENT_TYPES_ARRAY } from 'src/consumer/constants'
import MentorPastEventsListing from 'src/mentor/components/MentorEventsPage/components/bookingListing/MentorPastEventsListing'
import SupportHeader from 'src/supportPortal/layout/SupportHeader'
import EngagementSettingsDialog from 'src/supportPortal/components/EngagementSettingsDialog'
import { canManageEngagement } from 'src/supportPortal/services/patientEngagementService'

const SORT_OPTIONS = [
  { label: 'Start Time', value: 'startTime' },
  { label: 'Booking Time', value: 'createdTime' },
]

export default function BookedEvents() {
  const [selectedEventType, setSelectedEventType] = useState(EVENT_TYPE_THERAPY_SESSION)
  const [sortingHandler, setSortingHandler] = useState(null)
  const [showOnlyPaidEvents, setShowOnlyPaidEvents] = useState(true)
  const tableRef = useRef(null)
  
  // Engagement dialog state
  const [engagementDialogOpen, setEngagementDialogOpen] = useState(false)
  const [selectedEventForEngagement, setSelectedEventForEngagement] = useState(null)
  const hasEngagementPermission = useMemo(() => canManageEngagement(), [])
  
  // Handle engagement button click from listing
  const handleEngagementClick = (bookedEvent) => {
    setSelectedEventForEngagement(bookedEvent)
    setEngagementDialogOpen(true)
  }

  return (
    <>
      <SupportHeader heading={'Bookings & Appointments'} />
      <div
        style={{
          background: '#35304a',
          padding: '10px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          marginBottom: '10px',
        }}
      >
        <div>
          <BaseUITabsComponent
            value={selectedEventType}
            onChange={setSelectedEventType}
            tabs={
              EVENT_TYPES_ARRAY
              //   ?.filter(
              //   (tab) =>
              //     tab?.id === EVENT_TYPE_THERAPY_SESSION ||
              //     tab?.id === EVENT_TYPE_CONSULTATION
              // )
            }
            getTabLabel={(tab) => tab?.title}
            getTabId={(tab) => tab?.id}
          />
        </div>
        <div
          className="d-flex align-items-center justify-content-end gap-2"
          style={{ color: 'white !important' }}
        >
          <FormControlLabel
            control={
              <Checkbox
                checked={showOnlyPaidEvents}
                onChange={() => setShowOnlyPaidEvents(!showOnlyPaidEvents)}
                sx={{
                  color: 'white !important',
                  '&.Mui-checked': {
                    color: 'white',
                  },
                }}
              />
            }
            label="Hide payment pending events"
            sx={{
              '& .MuiFormControlLabel-label': {
                color: 'white !important',
              },
            }}
          />
          <SortingHandler
            sortValue={sortingHandler}
            setSortValue={setSortingHandler}
            getOptionLabel={(option) => option?.label}
            getOptionValue={(option) => option?.value}
            sortOptions={SORT_OPTIONS}
            outerDivStyle={{
              marginLeft: '10px',
              color: 'white',
              fontSize: '14px',
              alignItems: 'center',
            }}
            buttonColor="primary"
            buttonVariant="contained"
          />
        </div>
      </div>
      <div style={{ maxWidth: '1200px', margin: '0 auto', width: '100%' }}>
        <MentorPastEventsListing
          key={`${selectedEventType}-${showOnlyPaidEvents}`}
          listingApiSignature="/api/secure/cc/support/events/all/paginated"
          showMentorName
          hideActions
          listOfPaymentLinksApiSignature="/api/secure/cc/support/events/user-payment-link/get"
          eventType={selectedEventType}
          sortingHandler={sortingHandler}
          showOnlyPaidEvents={showOnlyPaidEvents}
          logsApiEndpoint="/api/secure/cc/support/events/logs/get"
          filterByBookedStatus={null}
          onEngagementClick={hasEngagementPermission ? handleEngagementClick : undefined}
        />
      </div>

      {/* Booked Event Engagement Dialog */}
      {hasEngagementPermission && (
        <EngagementSettingsDialog
          open={engagementDialogOpen}
          onClose={() => {
            setEngagementDialogOpen(false)
            setSelectedEventForEngagement(null)
          }}
          targetType="booked-event"
          target={selectedEventForEngagement}
          onSuccess={() => {
            // Optionally refresh the listing
          }}
        />
      )}
    </>
  )
}
